import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
};
export function Countdown({
  size = 'lg'
}: CountdownProps) {
  const {
    days,
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown();
  if (expired) return null;
  const units = [{
    value: days,
    label: 'Days'
  }, {
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }].filter(unit => unit.label !== 'Days' || Number(days) > 0);
  const box = size === 'lg' ? 'min-w-[68px] px-3 py-3 text-3xl sm:min-w-[92px] sm:px-4 sm:py-4 sm:text-5xl' : 'min-w-[58px] px-2.5 py-2.5 text-2xl sm:min-w-[68px] sm:px-3 sm:py-3 sm:text-3xl';
  return <div className="flex flex-wrap items-stretch justify-center gap-1.5 sm:gap-3" role="timer" aria-label="Time remaining at the launch price" data-id="element-102" data-mp="373kt3g3rvqe9">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-103" data-mp="15awl6tg6oes5" data-mpi={index}>
          {index > 0 && <span className="self-center font-serif text-xl text-white/35 sm:text-2xl" aria-hidden="true" data-id="element-104" data-mp="y0es26zuwm44">
              :
            </span>}
          <div className={`rounded-xl border border-white/12 bg-white/[0.06] text-center ${box}`} data-id="element-105" data-mp="t094b1wpjjrb">
            <span className="block font-serif font-semibold tabular-nums text-white" data-id="element-106" data-mp="17ssu70uujuqt">
              {unit.value}
            </span>
            <span className="mt-1 block font-sans text-[10px] uppercase tracking-[0.1em] text-white/70 sm:tracking-[0.14em]" data-id="element-107" data-mp="f1snuj91mevz">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}